import React from 'react';
import {RecordingBrowseCommon} from './RecordingBrowseCommon';
import {PAGE_TITLE_BASE} from './../../constants.js';
import { Header, Segment, Grid, Message } from 'semantic-ui-react'

export function RecordingBrowse(props) {
	document.title = 'Recordings | ' + PAGE_TITLE_BASE;

	return (
		<div>
			<Segment inverted>
				<Header inverted as='h1' style={{textAlign:'center'}}>
					Browse Recordings and Performances
				</Header>
			</Segment>
			<RecordingBrowseCommon/>
		</div>
	);
}